jQuery(document).ready( function($) {
    if ( jQuery().owlCarousel ) {
        $('.js-owl-carousel').owlCarousel({
            nav: true,
            navText: [
                '<svg class="svg-chevron-left-dims"><use xlink:href="#chevron-left"></use></svg>', 
                '<svg class="svg-chevron-right-dims"><use xlink:href="#chevron-right"></use></svg>'    
            ],
            responsive: {
                0 : {
                    items: 1,
                    nav: true
                },
                576 : {
                    items: 2,
                    nav: true
                },
                992 : {
                    items: 3,
                    nav: true
                }
            }
        });
    }
});